import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/landing";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * recentBuyers.length));
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const cycle = () => {
      setMinutesAgo(1 + Math.floor(Math.random() * 14));
      setShow(true);
      hideTimer = window.setTimeout(() => {
        setShow(false);
        nextTimer = window.setTimeout(() => {
          setIndex(i => (i + 1 + Math.floor(Math.random() * 3)) % recentBuyers.length);
          cycle();
        }, GAP);
      }, VISIBLE_FOR);
    };
    const startTimer = window.setTimeout(cycle, FIRST_DELAY);
    return () => {
      window.clearTimeout(startTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 top-3 z-50 flex justify-center sm:inset-x-auto sm:bottom-6 sm:left-6 sm:top-auto sm:justify-start" aria-live="polite" data-id="element-241" data-mp="1awz7728c9djk">
      <AnimatePresence data-id="element-242" data-mp="n8y5ac5o0vd4">
        {show && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_-8px_rgba(0,0,0,0.45)] ring-1 ring-slate-200" role="status" data-id="element-243" data-mp="i9bro1lxdd3s">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-slate-100 object-contain" data-id="element-244" data-mp="2aobfst9bmaz5" />
            <div className="min-w-0" data-id="element-245" data-mp="2fpqxcbcahzcs">
              <p className="text-[14px] leading-snug text-slate-700" data-id="element-246" data-mp="2km7lh5jhodpv">
                <span className="font-bold text-ink" data-id="element-247" data-mp="2plu11lmsi61u">{buyer.name}</span> from{" "}
                <span className="font-semibold text-ink" data-id="element-248" data-mp="2pjrc74xdiiyp">{buyer.country}</span> just purchased the Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[12px] font-medium text-slate-500" data-id="element-249" data-mp="1wwww0k7la5r1">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-after" aria-hidden="true" data-id="element-250" data-mp="21wj98tnf3lzu" />
                {minutesAgo} min ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-400 transition-colors duration-150 ease-out hover:text-slate-700" aria-label="Close notification" data-id="element-251" data-mp="26osvnzpbq3xd">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="3relyxakg8c4o" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}